<script setup lang="ts">
import { useAccount, useSignMessage } from "@wagmi/vue";
import { useAppKit } from "@reown/appkit/vue";
// import { signsMessage } from "@/utils/config";
import { watch, ref } from "vue";
import "./Header.scss";
import { authApi } from "@/api/sign";
import { useRouter } from "vue-router"; // 添加 router 导入
import { setLocale, type SupportedLocales } from "@/locales";
const { open, close } = useAppKit();
const { address } = useAccount();
const { signMessageAsync } = useSignMessage();
const { getSignMsg, setSignApi } = authApi;
import {
  faqUrlApi,
  xUrlApi,
  tgUrlApi,
  insUrlApi,
  disUrlApi,
} from "@/api/other";
import { useI18n } from "vue-i18n";

const router = useRouter(); // 使用 router
const { t, locale } = useI18n();

defineOptions({
  name: "Header",
});

interface TabItem {
  label: string;
  url?: string;
  visible?: boolean;
  child?: TabItem[];
}

const tabList = ref<TabItem[]>([
  { label: "nav.menu.extinct", url: "/" },
  {
    label: "nav.menu.iceAge",
    url: "/child",
    visible: false,
    child: [
      { label: "nav.menu.iceAge", url: "/child" },
      { label: "nav.menu.purchase", url: "/market" },
      // { label: "nav.menu.purchase", url: "/market" },
    ],
  },
  // { label: "nav.menu.cretaceous", url: "" },
  { label: "nav.menu.market", url: "" },
  { label: "nav.menu.nftGame", url: "" },
  { label: "nav.menu.museum", url: "" },
  { label: "nav.menu.irlEvents", url: "" },
  {
    label: "nav.menu.more",
    url: "/notice",
    visible: false,
    child: [
      { label: "nav.menu.announcement", url: "/notice" },
      { label: "nav.menu.whitepaper", url: "/purchase" },
      { label: "FAQ", url: "FAQ" },
    ],
  },
]);
const tabIndex = ref(0);
const isShow = ref(false);
const select = ref(false);
const selectBg = ref(false);
const isConnecting = ref(false);
const tabChildUrl = ref("");
const tabChildIndex = ref(0);

// 格式化地址
const formatAddress = (address: string) => {
  return `${address.slice(0, 4)}...${address.slice(-4)}`;
};

// 获取签名
const getSign = async (address: string) => {
  const signRes = await getSignMsg({ address });
  console.log("signRes:", signRes);
  return signRes;
};

const goPathUrl = async (type: string) => {
  // 社交媒体跳转
  let api;
  switch (type) {
    case "tg":
      api = tgUrlApi;
      break;
    case "dis":
      api = disUrlApi;
      break;
    case "ins":
      api = insUrlApi;
      break;
    case "x":
      api = xUrlApi;
      break;
  }

  if (api) {
    try {
      const res = await api();
      if (res.code === 200 && res.data) {
        window.location.href = res.data as string;
      }
    } catch (error) {
      console.error(`Failed to fetch ${type} URL:`, error);
    }
  }
};
const toggleLanguage = () => {
  select.value = !select.value;
  selectBg.value = !selectBg.value;
};

const toggleLanguageCk = (lang: string) => {
  const locale = lang === "zh" ? "zh-cn" : "en-us";
  setLocale(locale as SupportedLocales);
  select.value = false;
  selectBg.value = false;
};
const tabCk = (index: number, item: any) => {
  if (item.child) {
    item.visible = !item.visible;

    // if (index !== this.tabIndex) {
    //   item.visible = false;
    //   console.log("aaaa");
    // }
    tabIndex.value = index;
    tabList.value.forEach((items, indexs) => {
      if (items.child && indexs !== index) {
        items.visible = false;
      }
    });
  } else {
    if (tabIndex.value === index || !item.url) return;
    tabIndex.value = index;
    router.push({ path: item.url, query: {} });
    isShow.value = false;
    tabList.value.forEach((item) => {
      item.visible = false;
    });
  }
};
const childCk = (childIndex: number, item: any, index: number) => {
  tabIndex.value = index;
  console.log(item.url);
  if (item.url === "FAQ") {
    console.log("FAQ");
    faqUrlApi().then((res: any) => {
      // 添加类型注解
      if (res.code === 200) {
        window.location.href = res.data;
      }
    });
  } else {
    if (tabChildUrl.value === item.url || !item.url) return;
    tabChildIndex.value = childIndex;
    tabChildUrl.value = item.url;
    router.push({ path: item.url, query: {} });
    isShow.value = false;
  }
};
// watch(
//   address,
//   async (newValue, oldValue) => {
//     // 这里可以添加你想要的处理逻辑
//     if (newValue) {
//       const data = await getSign(newValue);
//       if (data.code === 200) {
//         const signature = await signMessageAsync({ message: data.data.msg });
//         const signTxt = await setSignApi({
//           msg: data.data.msg,
//           sign: signature,
//         });
//         console.log("signTxt----:", signTxt);
//       }
//       console.log("data----:", data.data.msg);
//     } else {
//       console.log("钱包未连接");
//     }
//   },
//   { deep: true }
// ); // 使用 deep: true 来深度监听对象的变化
// 监听 address 变化
watch(address, async (newValue, oldValue) => {
  // 如果新旧值相同，则不执行
  if (newValue === oldValue || !newValue) {
    return;
  }

  const data = await getSign(newValue);
  if (data.code === 200) {
    const signature = await signMessageAsync({ message: data.data.msg });
    const signTxt = await setSignApi({
      msg: data.data.msg,
      sign: signature,
    });
    console.log("signTxt----:", signTxt);
  }
  console.log("data----:", data.data.msg);
}); // 移除 deep: true，因为我们只需要监听 address 的值变化

const handleConnectWallet = () => {
  if (address) {
    open();
  } else {
    close();
  }
};
// 监听路由变化
watch(
  () => router.currentRoute.value.path,
  (newPath) => {
    initActiveTab();
  }
);
// 添加初始化高亮的函数
const initActiveTab = () => {
  const currentPath = router.currentRoute.value.path;

  // 遍历查找匹配的路由
  tabList.value.forEach((item, index) => {
    if (item.url === currentPath) {
      tabIndex.value = index;
      return;
    }

    // 检查子菜单
    if (item.child) {
      const childIndex = item.child.findIndex(
        (child) => child.url === currentPath
      );
      if (childIndex !== -1) {
        tabIndex.value = index;
        tabChildIndex.value = childIndex;
        tabChildUrl.value = currentPath;
      }
    }
  });
};
</script>

<template>
  <div>
    <!-- <appkit-button balance="hide" label="连接钱包" /> -->
    <!--pc端-->
    <div class="nav">
      <div class="nav-left">
        <img src="@/assets/home/logo.png" alt="" class="logo-icon" />
        <div class="tab">
          <div
            class="tab-item"
            v-for="(item, index) in tabList"
            :key="index"
            :class="{ active: tabIndex === index }"
            @click="tabCk(index, item)"
          >
            <div class="tab-item-txt">
              {{ t(item.label) }}
              <template v-if="item.child">
                <img
                  src="@/assets/nav/xx.png"
                  alt=""
                  class="bottom-icon"
                  v-if="!item.visible"
                />
                <img
                  src="@/assets/nav/xs.png"
                  alt=""
                  class="bottom-icon"
                  v-else
                />
              </template>
            </div>
            <div class="coming-soon" v-if="!item.url">
              {{ t("home.comingSoon") }}
            </div>
            <template v-if="item.child && item.visible">
              <div class="menu-tip">
                <div
                  v-for="(childItem, childIndex) in item.child"
                  :key="childIndex"
                  class="menu-tip-item"
                  :class="{
                    'border-none': childIndex === item.child.length - 1,
                  }"
                  @click="childCk(childIndex, childItem, index)"
                >
                  {{ t(childItem.label) }}
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
      <div class="nav-right">
        <div
          class="nav-btn margin-right-15 w-131 left-btn"
          :class="{ connecting: isConnecting }"
          @click="handleConnectWallet"
        >
          <div class="nav-item">
            {{
              address && address
                ? formatAddress(address)
                : t("nav.connectWallet")
            }}
          </div>
        </div>
        <div
          class="nav-btn"
          :class="{ 'switch-language': selectBg }"
          @click="toggleLanguage"
        >
          <div class="nav-item">
            {{ t("nav.switchLanguage") }}
            <img src="@/assets/home/x.png" alt="" class="x-icon" />
          </div>
          <div class="dropdown-content" v-show="select">
            <div @click.stop="toggleLanguageCk('zh')">繁体中文</div>
            <div @click.stop="toggleLanguageCk('en')">English</div>
          </div>
        </div>
      </div>
    </div>
    <!--手机端-->
    <div class="mobile-nav-box" @click="isShow = false" v-if="isShow"></div>
    <div class="mobile-nav">
      <img src="@/assets/home/logo.png" alt="" class="logo-icon" />
      <div class="mobile-right">
        <div class="switch" v-show="!selectBg" @click="toggleLanguage">
          <div style="display: flex; align-items: center">
            {{ t("nav.switchLanguage") }}
            <img src="@/assets/home/x.png" alt="" class="x-icon" />
          </div>
          <div class="dropdown-content" v-show="select">
            <div @click.stop="toggleLanguageCk('zh')">繁体中文</div>
            <div @click.stop="toggleLanguageCk('en')">English</div>
          </div>
        </div>

        <div
          class="switch-language-mobile"
          v-show="selectBg"
          @click="toggleLanguage"
        >
          <div style="display: flex; align-items: center">
            {{ t("nav.switchLanguage") }}
            <img src="@/assets/home/x.png" alt="" class="x-icon" />
          </div>
          <div class="dropdown-content" v-show="select">
            <div @click.stop="toggleLanguageCk('zh')">繁体中文</div>
            <div @click.stop="toggleLanguageCk('en')">English</div>
          </div>
        </div>
        <div
          class="nav-btn margin-right-15 w-131 left-btn"
          :class="{ connecting: isConnecting }"
          @click="handleConnectWallet"
        >
          <div class="nav-item">
            {{
              address && address
                ? formatAddress(address)
                : t("nav.connectWallet")
            }}
          </div>
        </div>
        <div class="right-icon">
          <img
            src="@/assets/nav/close.png"
            alt=""
            class="close-icon"
            v-if="isShow"
            @click="isShow = false"
          />
          <img
            src="@/assets/nav/more.png"
            alt=""
            class="more-icon"
            @click="isShow = true"
            v-else
          />
        </div>
      </div>
    </div>
    <div class="mobile-menu" @click.stop v-if="isShow">
      <div class="tab">
        <div
          class="tab-item"
          v-for="(item, index) in tabList"
          :key="index"
          :class="{ active: tabIndex === index }"
          @click="tabCk(index, item)"
        >
          <div class="item-txt">
            <div class="tab-item-txt">
              {{ t(item.label) }}
              <template v-if="item.child">
                <img
                  src="@/assets/nav/xx.png"
                  alt=""
                  class="bottom-icon"
                  v-if="!item.visible"
                />
                <img
                  src="@/assets/nav/xs.png"
                  alt=""
                  class="bottom-icon"
                  v-else
                />
              </template>
            </div>

            <div class="coming-soon" v-if="!item.url">
              {{ t("home.comingSoon") }}
            </div>

            <template v-if="item.child && item.visible">
              <div class="menu-tip">
                <div
                  v-for="(childItem, childIndex) in item.child"
                  :key="childIndex"
                  class="menu-tip-item"
                  :class="{
                    'border-none': childIndex === item.child.length - 1,
                  }"
                  @click="childCk(childIndex, childItem, index)"
                >
                  {{ t(childItem.label) }}
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>

      <div class="menu-footer">
        <img
          src="@/assets/nav/t.png"
          alt=""
          class="f-icon"
          @click="goPathUrl('x')"
        />
        <img
          src="@/assets/nav/d.png"
          alt=""
          class="f-icon margin-left"
          @click="goPathUrl('dis')"
        />
        <img
          src="@/assets/nav/i.png"
          alt=""
          class="f-icon"
          @click="goPathUrl('ins')"
        />
        <img
          src="@/assets/home/tg.png"
          alt=""
          class="f-icon margin-left-two"
          @click="goPathUrl('tg')"
        />
      </div>
    </div>
  </div>
</template>
